class StepSummary {
  constructor() {
    this._init();
  }

  _init() {
    const cgvCheckbox = document.getElementById('cgv') as HTMLInputElement;
    const confidentialiteCheckBox = document.getElementById('confidentialite') as HTMLInputElement;
    const cgvError = document.getElementById('cgv-error');
    const submitButton = document.querySelector(
      '.checkout-common__submit'
    ) as HTMLButtonElement;

    if (!cgvCheckbox || !confidentialiteCheckBox || !submitButton) return;

    const updateState = () => {
      // 1. Logique du bouton Submit (CGV ET Confidentialité doivent être cochés)
      const canSubmit = cgvCheckbox.checked && confidentialiteCheckBox.checked;
      submitButton.disabled = !canSubmit;

      // 2. Affichage de l'erreur CGV (si non coché)
      if (cgvError) {
        cgvError.style.display = cgvCheckbox.checked ? 'none' : 'block';
      }


    };

    // Listeners
    cgvCheckbox.addEventListener('change', updateState);
    confidentialiteCheckBox.addEventListener('change', updateState);
  }
}

new StepSummary();
